import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../style.css';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { formatAmount, checkUserPermissions, getFormattedDateForApiLogs } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import moment from 'moment';
import { TIMEZONES, theme, USER_ROLES } from 'utils/constant';
import { formatInTimeZone } from 'date-fns-tz';
import { JSONTree } from 'react-json-tree';
import { getProductApiLogs, getSingleProduct, removeProductFromPlan, getProductPlans } from 'api/subscriptions';
import { Space, Tooltip, Table, Collapse, Modal, Empty, Button } from 'antd';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { ResetButton } from '../../../components/Atom/Button';
import { useParams } from 'react-router-dom';
import LoadingSkeleton from '../../../components/Skeleton/index';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
const { Panel } = Collapse;

export const ViewProductDetails = () => {
  const [apiLogs, setApiLogs] = useState(null);
  const [productPlan, setProductPlan] = useState(null);
  const [removePlanId, setRemovePlanId] = useState('');
  const [removePlanModal, setRemovePlanModal] = useState(false);
  const [isPlanRemoving, setIsPlanRemoving] = useState(false);
  const location = useLocation();
  const store = useSelector((state) => state.company.store);
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchProductData = async () => {
    const response = await getSingleProduct(location?.state?.record?.store_id || store?._id, id || location?.state?.record?.product_id);
    return response?.data?.data || null;
    /*   if (data) {
      productPlans(data);
      productApiLogs(data);
    }
    return data; */
  };
  const {
    data: record,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`product_${id || location?.state?.record?.product_id}`, fetchProductData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store]);

  useEffect(() => {
    if (record) {
      productPlans(record);
      productApiLogs(record);
    }
  }, [record]);

  const productApiLogs = async (data) => {
    const product_id = data?.product_id;
    const storeId = data?.store_id;
    const { start_date, end_date } = getFormattedDateForApiLogs(data);
    const response = await getProductApiLogs(product_id, storeId, start_date, end_date);
    if (response?.data?.success) {
      setApiLogs(response?.data?.data?.logs || null);
    }
  };

  const productPlans = async (data) => {
    const product_id = data?.product_id;
    const storeId = data?.store_id;
    const response = await getProductPlans(product_id, storeId);
    setProductPlan(response?.data?.data || null);
  };

  const handleRemovePlan = async (product_id) => {
    setIsPlanRemoving(true);
    const response = await removeProductFromPlan(record?.store_id, removePlanId, product_id);
    if (response?.data?.success) {
      setRemovePlanModal(false);
      refetch();
    }
    setIsPlanRemoving(false);
  };

  const columns = [
    {
      title: 'Plan ID',
      render: (value) => <ShortenId value={value?.plan_id} />,
      key: 'plan',
    },
    {
      title: 'Active',
      render: (value) => (value?.active === true ? 'Yes' : 'No'),
      key: 'active',
    },
    {
      title: 'Every',
      render: (value) => value?.every,
      key: 'every',
    },
    {
      title: 'Interval',
      render: (value) => value?.interval,
      key: 'interval',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      (setRemovePlanModal(true), setRemovePlanId(data?.plan_id));
                    }}
                    style={{ cursor: 'pointer' }}>
                    Remove
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const features = [
    {
      render: (value) => value,
      key: 'feature',
    },
  ];
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Product',
        href: '/subscriptions/product',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };
  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const generalInformation = [
    { label: 'Product ID', value: <ShortenId value={record?.product_id} /> },
    { label: 'Name', value: record?.name },
    { label: 'Active', value: record?.active === true ? 'Yes' : 'No' },
    { label: 'Price', value: formatAmount(record?.price, record?.currency) },
    { label: 'Currency', value: record?.currency },
    { label: 'Creation Time', value: record?.createdAt ? formatInTimeZone(record?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
    { label: 'Last Update Time', value: record?.updatedAt ? formatInTimeZone(record?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
  ];

  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums'>
          <div
            className='back-button'
            onClick={() =>
              navigate('/subscriptions/product', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mb-0 mt-4'>Product Detail</div>
      </div>
      <div className='subscription-details logs-details'>
        {isLoading ? (
          <LoadingSkeleton />
        ) : !record ? (
          store?.isSelected ? (
            <div className='empty-custom-style'>
              <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className='empty-custom-style'>
              <Empty description={'Select store from the drop-down menu above'} />
            </div>
          )
        ) : (
          <>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Product Detail</h3>
              </div>
              <div className='detail-card'>
                {generalInformation?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Description</h3>
              </div>
              <div className='description'>
                <div className='description-value empty-details'>
                  <span>{record?.description || 'No Description'}</span>
                </div>
              </div>
            </div>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Features</h3>
              </div>
              <div className='table-container feature-container'>
                {record?.features?.length > 0 ? (
                  <Table columns={features} dataSource={record?.features} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Feature</div>
                  </div>
                )}
              </div>
            </div>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Associated Plans</h3>
              </div>
              <div className='table-container'>
                {productPlan?.length > 0 ? (
                  <Table columns={columns} dataSource={productPlan} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Plan</div>
                  </div>
                )}
              </div>
            </div>
            <Collapse expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />} defaultActiveKey={['1']}>
              {apiLogs?.length > 0 && (
                <Panel header='API Logs' className='border' key='1'>
                  <div className='apiLogs'>
                    <Collapse>
                      {apiLogs?.map((data, index) => {
                        if (data?.response?.encryptionKey) {
                          delete data?.response?.encryptionKey;
                        }
                        return (
                          <Panel
                            header={
                              <div className='header-api-log'>
                                <h1>{data?.end_point_url}</h1>
                                <span className='request-type'>{data?.api_call_name}</span>
                              </div>
                            }
                            className='border'
                            key={`${index}1`}>
                            <div className=''>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <CopyToClipboardButton
                                  content={{
                                    'Request Time': moment(data?.created_at).format('MMM D, YYYY h:mm:ss A'),
                                    'Request Body': data?.payload ?? null,
                                    'Response Body': data?.response ?? null,
                                  }}
                                />
                              </div>
                              <h1 style={{ fontWeight: 'bold' }}>Request Time</h1>
                              <p style={{ margin: '5px 0px' }}>{moment(data?.created_at).format('MMM D, YYYY h:mm:ss A')}</p>
                              <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Request Body</h1>
                              <JSONTree key={`${index}2`} data={data?.payload ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                              <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Response Body</h1>
                              <JSONTree key={`${index}3`} data={data?.response ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>
                  </div>
                </Panel>
              )}
            </Collapse>
          </>
        )}
      </div>
      <Modal
        className='bin-modal'
        centered
        open={removePlanModal}
        width={400}
        onCancel={() => {
          setRemovePlanModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isPlanRemoving }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Remove Product From Plan</header>
        <div className='mb-8'>
          Are you sure you want to remove this Product from Plan
          <span>{'?'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setRemovePlanModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleRemovePlan(record?.product_id)} loading={isPlanRemoving}>
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
};
